import {GameStateEnums} from '../../../../shared/GameEnums'
import {UIGameMechanic} from '../../../shared/scripts/ui_game/UIGameEventController'
import {UIGameManager} from '../../../shared/scripts/ui_game/UIGameManager'
import {UIMDeviceHandler} from '../ui_html/UIMDeviceHandler'

export class UIMGameReviewController implements UIGameMechanic {
    private readonly uiGameManager: UIGameManager

    constructor(uiGameManager: UIGameManager) {
        this.uiGameManager = uiGameManager
        this.uiGameManager.eventController.registerUIGameMechanic(this)
    }
    onEvent(data: any, eventType: GameStateEnums.UIGameEventEnums) {
        switch(eventType) {
            case GameStateEnums.UIGameEventEnums.FeedbackFormSubmitted: this.onFeedbackFormSubmitted(data)
                break
            default: break
        }
    }

    // eslint-disable-next-line class-methods-use-this
    private onFeedbackFormSubmitted(rating: number): void {
        if(rating <= 4) return
        UIMDeviceHandler.requestReview()
    }
}
